import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { MUIDataTableMeta } from "mui-datatables";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components";

export const GetBondsListColumns = (ID_Anag: string, ID_FideAffidamento: string) => [
    {
        name: "ID_Polizza",
        label: "ID",
        options: {
            filter: false
        }
    },
    {
        name: "Polizza",
        label: Trad.Trad("Polizza"),
        options: {
            filter: false,
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CDatiPolizza(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return (
                    <>
                        {val}
                        <br />
                        {rowData.Contraente}
                    </>
                );
            }
        }
    },
    {
        name: "DataEffetto",
        label: Trad.Trad("Data effetto"),
        options: {
            filter: false,
            customBodyRender: (val: Date) => Trad.Trad(val)
        }
    },
    {
        name: "DataFine",
        label: Trad.Trad("Data fine"),
        options: {
            filter: false,
            customBodyRender: (val: Date) => Trad.Trad(val)
        }
    },
    {
        name: "TipoProdotto",
        label: Trad.Trad("TipoProdotto"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "TipoRamo",
        label: Trad.Trad("TipoRamo"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "StatoPolizza",
        label: Trad.Trad("Stato"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.Trad(val)
        }
    },
    {
        name: "DataInizioCopertura",
        label: Trad.Trad("DataInizioCopertura"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: Date | undefined) => Glob.DataValoreTrad(val)
        }
    },
    {
        name: "DataFineCopertura",
        label: Trad.Trad("DataFineCopertura"),
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val: Date | undefined) => Glob.DataValoreTrad(val)
        }
    },
    {
        name: "Edit",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CDatiPolizza(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return (
                    <a href={`/anagrafica/${ID_Anag}/FideAffidamento/${ID_FideAffidamento}/FidePolizza/${rowData.ID_Polizza}`}>
                        <Tooltip title={Trad.Trad("Modifica")}>
                            <IconButton aria-label="edit" size="small">
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                    </a>
                );
            }
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/BondsList/BondsListColumns.tsx